import React, { useState } from 'react';
import { MapContainer, TileLayer, CircleMarker } from 'react-leaflet';

const formatCoord = (value) => (value == null ? '—' : String(value));

function ImageBox({ id }) {
  const [failed, setFailed] = useState(false);
  if (!failed) {
    return (
      <div className="rec-media-box rec-media-image">
        <img src={`/api/images/${encodeURIComponent(id)}`} alt="" onError={() => setFailed(true)} />
      </div>
    );
  }
  return (
    <div className="rec-media-box rec-media-placeholder">
      <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909M3.75 18h16.5A1.5 1.5 0 0 0 21.75 16.5V7.5A1.5 1.5 0 0 0 20.25 6H3.75A1.5 1.5 0 0 0 2.25 7.5v9A1.5 1.5 0 0 0 3.75 18ZM9.75 9.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        />
      </svg>
      <span>No image available</span>
    </div>
  );
}

// Two-column media block: image on the left, map on the right with the coordinates underneath.
export default function RecordMedia({ record }) {
  const lat = record.Location__Latitude__s;
  const lng = record.Location__Longitude__s;

  return (
    <div className="rec-media">
      <ImageBox id={record.DaftId__c} />
      <div className="rec-media-map-col">
        {lat != null && lng != null ? (
          <div className="rec-media-box rec-media-map">
            <MapContainer key={`${lat},${lng}`} center={[lat, lng]} zoom={15} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
              <TileLayer
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                maxZoom={19}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <CircleMarker
                center={[lat, lng]}
                radius={8}
                pathOptions={{ weight: 2, color: '#ffffff', fillColor: '#3b82f6', fillOpacity: 1 }}
              />
            </MapContainer>
          </div>
        ) : (
          <div className="rec-media-box rec-media-empty">No coordinates available</div>
        )}
        <p className="rec-coords">
          <strong>Latitude:</strong> {formatCoord(lat)}
          <span className="rec-coords-sep">|</span>
          <strong>Longitude:</strong> {formatCoord(lng)}
        </p>
      </div>
    </div>
  );
}
